import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';

import { Detail } from '../../../models/detail';

import { AlertService } from '../../../services/common/alert.service';
import { DetailService } from '../../../services/matters/detail.service';

import { TinymceComponent } from '../../common/tinymce/tinymce.component';

@Component({
  selector: 'app-matter-detail-form',
  templateUrl: './matter-detail-form.component.html',
  styleUrls: ['./matter-detail-form.component.css'],
})
export class MatterDetailFormComponent implements OnInit {
  @Input() matter_id: number;
  @Input() detail_id: number;

  @Output() formResult: EventEmitter<string> = new EventEmitter();

  @ViewChild('tinymce', { static: true }) tinymceComponent: TinymceComponent;

  form_options: any = {
    detail_types: [],
  };

  detail: Detail = new Detail();

  formSubmitting: boolean = false;
  formSubmitted: boolean = false;

  constructor(private alertService: AlertService, private detailService: DetailService) {
    this.detailService.getFormOptions().then((response_json) => {
      this.form_options = response_json;
      if (!this.detail_id) this.detail.detail_type_id = this.form_options.detail_types[0].id;
    });
  }

  ngOnInit() {
    if (this.detail_id)
      this.detailService.getDetail(this.detail_id).then((response_json) => {
        this.detail = response_json;
        this.tinymceComponent.setContent(this.detail.value);
      });
    else if (this.matter_id) this.detail.matter_id = this.matter_id;
  }

  fieldShowErrorMessage(field: any) {
    if (!field.valid && this.formSubmitted) return true;
    else return false;
  }

  saveDetail(formValid: boolean) {
    this.formSubmitted = true;
    if (formValid) {
      this.formSubmitting = true;
      let scope = this;
      this.detailService
        .saveDetail(this.detail)
        .then((response_json) => {
          this.formSubmitting = false;
          if (response_json.text == 'Detail created' || response_json.text == 'Detail updated') {
            this.alertService.alert_status_success(response_json.text);
            this.formResult.emit('Form Saved');
          } else this.alertService.alert_status_danger(response_json.text || 'Error saving detail');
        })
        .catch(function () {
          scope.formSubmitting = false;
          scope.alertService.alert_status_danger('Error saving detail');
        });
    }
  }

  cancelForm() {
    this.formResult.emit('Form Cancelled');
  }
}
